export default function PrivacyPageEn() {
  return (
    <section className="section" style={{ maxWidth: "800px", margin: "0 auto" }}>
      <h2>Privacy Policy</h2>

      <h3>1. Data Controller</h3>
      <p>
        Art Rafał Tołczyk<br />
        Email: kontakt@arttolczyk.pl
      </p>

      <h3>2. Data We Collect</h3>
      <ul>
        <li>Name and surname</li>
        <li>Email address</li>
        <li>Delivery address</li>
        <li>Order details</li>
        <li>Payment information (handled securely by PayU / Przelewy24)</li>
      </ul>

      <p><i>We do not store credit card numbers.</i></p>

      <h3>3. Purpose of Data Processing</h3>
      <p>Personal data is used to:</p>
      <ul>
        <li>process and ship orders</li>
        <li>send order confirmations</li>
        <li>contact customers when necessary</li>
      </ul>

      <h3>4. Legal Basis</h3>
      <p>GDPR Art. 6(1)(b) – contract execution.</p>

      <h3>5. Sharing of Data</h3>
      <p>Data may be shared only with:</p>
      <ul>
        <li>payment operators (Przelewy24 / PayU)</li>
        <li>delivery companies</li>
      </ul>
      <p>We never sell personal data.</p>

      <h3>6. Customer Rights</h3>
      <p>You have the right to:</p>
      <ul>
        <li>access your data</li>
        <li>correct your data</li>
        <li>request deletion</li>
        <li>limit processing</li>
      </ul>

      <p>Requests should be sent to: kontakt@arttolczyk.pl</p>

      <h3>7. Cookies</h3>
      <p>
        The website uses minimal cookies necessary for language preferences and
        shopping cart functionality.
      </p>
    </section>
  );
}

